import { render, staticRenderFns } from "./CompositeCustomer.vue?vue&type=template&id=45be4c52&scoped=true&"
import script from "./CompositeCustomer.vue?vue&type=script&lang=js&"
export * from "./CompositeCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CompositeCustomer.vue?vue&type=style&index=0&id=45be4c52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45be4c52",
  null
  
)

export default component.exports